import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Tag } from '../models/tag';
import { TagEntityResult } from '../models/tags/tags-result';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class TagsService {
  constructor(private http: HttpClient) {}

  listTags(type: string): Observable<Tag[]> {
    const url = `${environment.apiBase}/${type}/tags`;
    if (isDevMode()) {
      console.log('[DEV] [TagsService] loading tags', type);
    }
    return this.http.get<Tag[]>(url, httpOptions);
  }

  tag(type: string, id: string, tag: string): Observable<TagEntityResult> {
    const url = `${environment.apiBase}/${type}/${id}/tag/${tag}`;
    return this.http.patch<TagEntityResult>(url, httpOptions);
  }

  removeTag(type: string, id: string, tag: string): Observable<TagEntityResult> {
    const url = `${environment.apiBase}/${type}/${id}/tag/${tag}`;
    return this.http.delete<TagEntityResult>(url, httpOptions);
  }
}
